import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { LoginGuard } from './shared/guards/login.guard';
import { PageAccessGuard } from './shared/guards/page-access.guard';
import { RestrictedGuard } from './shared/guards/restricted.guard';

const routes: Routes = [
  
  {
    path: '',
    redirectTo: 'accounts',
    pathMatch: 'full'
  },
  {
    path: '?pt=:num',  
    redirectTo: '/welcome/?pt=:num',
    pathMatch: 'full'
  },
  {
    path: 'welcome/?pt=:num',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/welcome.page').then( m => m.WelcomePage)
  },
  {
    path: 'welcome',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/welcome.page').then( m => m.WelcomePage)
  },
  {
    path: 'register',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/welcome.page').then( m => m.WelcomePage)
  },
  {
    path: 'forgot-password',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/forgot-password/forgot-password.page').then( m => m.ForgotPasswordPage)
  },
  {
    path: 'signup/pswdset/token/:token',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/welcome/forgot-password-token/forgot-password-token.page').then( m => m.ForgotPasswordTokenPage)
  },
  {
    path: 'epaymentsmobile',
    children: [
      {path: 'redirecthome/failure' , loadChildren: () => import('./pages/payments-redirection/payments-redirection.module').then( m => m.PaymentsRedirectionPageModule)},
      {path: 'redirecthome/success' , loadChildren: () => import('./pages/payments-redirection/payments-redirection.module').then( m => m.PaymentsRedirectionPageModule)},
      {path: 'redirecthome' , loadChildren: () => import('./pages/payments-redirection/payments-redirection.module').then( m => m.PaymentsRedirectionPageModule)},
      {path: 'powercash21result' , loadChildren: () => import('./pages/payments-redirection/payments-redirection.module').then( m => m.PaymentsRedirectionPageModule)},
      {path: 'resultdeposit/status/failed' , loadChildren: () => import('./pages/payments-redirection/payments-redirection.module').then( m => m.PaymentsRedirectionPageModule)},
      {path: 'resultdeposit/status/success' , loadChildren: () => import('./pages/payments-redirection/payments-redirection.module').then( m => m.PaymentsRedirectionPageModule)},
      {path: 'isignthisresult' , loadChildren: () => import('./pages/payments-redirection/payments-redirection.module').then( m => m.PaymentsRedirectionPageModule)},
    ]
  },
  {
    path: 'callback',
    children: [
      {path: '**' , loadChildren: () => import('./pages/payments-redirection/payments-redirection.module').then( m => m.PaymentsRedirectionPageModule)},
    ]
  },
  {
    path: 'epayments',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    children: [
      {path: 'redirecthome/failure' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'redirecthome/success' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'redirecthome' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'powercash21result' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'resultdeposit/status/failed' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'resultdeposit/status/success' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
      {path: 'isignthisresult' , loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)},
    ]
  },
  {
    path: 'accounts',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule),
    data: { preload: true },
  },
  {
    path: 'accounts/create-new/live',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)
  },
  {
    path: 'payments/deposit',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsPageModule)
  },
  {
    path: 'payments/uploadproofofcryptos',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsPageModule)
  },
  {
    path: 'payments/withdraw',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsPageModule)
  },
  {
    path: 'payments/internal-transfer',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsPageModule)
  },
  {
    path: 'payments',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard], 
    loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsPageModule),
    data: { preload: true },
  },
  {
    path: 'complete-profile',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/complete-profile-v2/complete-profile-v2.module').then( m => m.CompleteProfileV2PageModule)
  },
  {
    path: 'upload',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/upload-docs-v2/upload-docs-v2.module').then( m => m.UploadDocsV2PageModule)
  },
  {
    path: 'view-more/notification-settings',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)
  },
  {
    path: 'view-more/change-language',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)
  },
  {
    path: 'view-more/communication-language',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)
  },
  {
    path: 'view-more/support',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)
  },
  {
    path: 'view-more/contacts',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)
  },
  {
    path: 'view-more/change-leverage',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)
  },
  {
    path: 'view-more/change-password',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)
  },
  {
    path: 'view-more',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/view-more/view-more.module').then( m => m.ViewMorePageModule)
  },
  {
    path: 'loyalty',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/loyalty/loyalty.module').then( m => m.LoyaltyPageModule),
    data: { preload: true },
  },
  {
    path: 'signup/verifyemail/token/:token',
    loadChildren: () => import('./pages/welcome/verify-email/verify-email.module').then( m => m.VerifyEmailPageModule)
  },
  {
    path: 'promotions',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/promotions/promotions.module').then( m => m.PromotionsPageModule)
  },
  {
    path: 'trading-stats',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/trading-stats/trading-stats.module').then( m => m.TradingStatsPageModule)
  },
  {
    path: 'version',
    loadChildren: () => import('./pages/version/version.module').then( m => m.VersionPageModule)
  },
  {
    path: 'news',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    children: [
      {path: '' , loadChildren: () => import('./pages/markets/news/news.module').then( m => m.NewsPageModule)},
      {path: ':id' , loadChildren: () => import('./pages/markets/news/news.module').then( m => m.NewsPageModule)} 
    ],
  },
  {
    path: 'instruments',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    children: [
      {path: '' , loadChildren: () => import('./pages/markets/instruments/instruments.module').then( m => m.InstrumentsPageModule)},
      {path: ':id' , loadChildren: () => import('./pages/markets/instruments/instruments.module').then( m => m.InstrumentsPageModule)} 
    ],
  },
  {
    path: 'calendar',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/markets/calendar/calendar.module').then( m => m.CalendarPageModule)
  },
  {
    path: 'ideas',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/markets/ideas/ideas.module').then( m => m.IdeasPageModule)
  },
  {
    path: 'pricing',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/markets/pricing/pricing.module').then( m => m.PricingPageModule)
  },
  {
    path: 'reports',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/reports/reports.module').then( m => m.ReportsPageModule)
  },
  {
    path: 'webinars',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/tools/webinars/webinars.module').then( m => m.WebinarsPageModule)
  },
  {
    path: 'education',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/tools/education/education.module').then( m => m.EducationPageModule)
  },
  {
    path: 'calculator',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/tools/calculator/calculator.module').then( m => m.CalculatorPageModule)
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/push-notifications/push-notifications.module').then( m => m.PushNotificationsPageModule)
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./pages/maintenance/maintenance.module').then( m => m.MaintenancePageModule)
  },
  {
    path: 'recovertoken/token',
    loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)
  },
  {
    path: 'recovertoken/token/:token',
    loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)
  },
  {
    path: 'recovertoken/token/:token/:returnUrl',
    children : [
      {path: '' , loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)},
      {path: ':id' , loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)},
      {path: '**' , loadChildren: () => import('./pages/recovertoken/recovertoken.module').then( m => m.RecovertokenPageModule)}
    ]
  }, 
  {
    path: 'copy-trading',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    children: [
      {path: '' , loadChildren: () => import('./pages/copy-trading/copy-trading.module').then( m => m.CopyTradingPageModule)},
      {path: 'follower' , loadChildren: () => import('./pages/copy-trading/copy-trading.module').then( m => m.CopyTradingPageModule)},
      {path: 'provider' , loadChildren: () => import('./pages/copy-trading/copy-trading.module').then( m => m.CopyTradingPageModule)},
    ],
    data: { preload: true },
  },
  {
    path: 'refreshment',
    canActivate: [AuthGuard, PageAccessGuard, RestrictedGuard],
    loadChildren: () => import('./pages/refreshment-time/refreshment-time.module').then( m => m.RefreshmentTimePageModule)
  },
  {
    // redirects @all unknown urls
    // needs to be last in routes array to work properly
    path: '**',
    redirectTo: 'accounts'
  }


];

// selective-preloading.strategy.ts
import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (!route.data?.['preload'] || !this.shouldPreloadOnCurrentConnection()) {
      return of(null);
    }

    return load();
  }

  private shouldPreloadOnCurrentConnection(): boolean {
    const connection = (navigator as any)?.connection ?? (navigator as any)?.mozConnection ?? (navigator as any)?.webkitConnection;

    if (!connection || connection.saveData) {
      return false;
    }

    return connection.effectiveType === '4g' || connection.effectiveType === '5g';
  }
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false,preloadingStrategy: SelectivePreloadingStrategy })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
